var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 1C13.5172 1 14.8642 1.98254 15.344 3.43921L19.4062 15.7725L21.7744 17.4148C22.1187 17.6536 22.0578 18.1757 21.6675 18.3304L12.7855 21.8501C12.2813 22.05 11.7187 22.05 11.2145 21.8501L2.33248 18.3304C1.94222 18.1757 1.88129 17.6536 2.22563 17.4148L4.59386 15.7725L8.65604 3.43921C9.13582 1.98254 10.4828 1 12 1ZM12 2.51806C11.1285 2.51806 10.3547 3.08248 10.0791 3.91926L8.90816 7.47427C10.9291 8.0569 13.071 8.05691 15.0919 7.4743L13.921 3.91926C13.6453 3.08248 12.8716 2.51806 12 2.51806ZM16.8952 12.9495C13.714 13.9978 10.286 13.9978 7.10479 12.9495L5.93417 16.5036C9.84025 18.0117 14.1598 18.0117 18.0658 16.5036L16.8952 12.9495Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCone);
export default __webpack_public_path__ + "static/media/cone.49b7889365ffa9197191c0078afdc69c.svg";
export { ForwardRef as ReactComponent };